/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'arrows': {
    width: 16,
    height: 16,
    viewBox: '0 0 14 14',
    data: '<path pid="0" d="M4.108 11.179L1.288 14H0v-1.227c0-.04 1.584-1.713 2.758-2.947L0 7.063h6.95L6.924 14zm5.784-8.357L12.712 0H14v1.227c0 .04-1.584 1.713-2.758 2.947L14 6.937H7.05L7.076 0z" fill-rule="evenodd"/>'
  }
})
